<div class="row">
  <div [ngClass]="middle ? 'col-4' : 'col-6'">
    <div class="small" *ngIf="left.top">
      {{ left.top }}
    </div>
    <div class="large" [ngStyle]="{'color': left.middleColor}">
      {{ left.middle }}
    </div>
    <div class="small">
      {{ left.bottom }}
    </div>
  </div>
  <div *ngIf="middle" class="col-4">
    <div class="small" *ngIf="middle.top">
      {{ middle.top }}
    </div>
    <div class="large" [ngStyle]="{'color': middle.middleColor}">
      {{ middle.middle }}
    </div>
    <div class="small">
      {{ middle.bottom }}
    </div>
  </div>
  <div [ngClass]="middle ? 'col-4' : 'col-6'">
    <div class="small" *ngIf="right.top">
      {{ right.top }}
    </div>
    <div class="large" [ngStyle]="{'color': right.middleColor}">
      {{ right.middle }}
    </div>
    <div class="small">
      {{ right.bottom }}
    </div>
  </div>
</div>
